import styled from "@emotion/styled";

import { ThemeMode } from "../../context/ThemeContext";

export const AppBodyLayoutWrapper = styled.div<{ mode: ThemeMode }>`
  box-sizing: border-box;
  padding: 32px 0 0;
  min-height: calc(100vh - 74px);
  background-color: ${({ mode }) => (mode === "dark" ? "#1F242A" : "#F0F0F0")};
  color: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#333333")};

  @media (max-width: 768px) {
    padding: 16px 0 0;
  }

  .MuiContainer-root {
    @media (max-width: 768px) {
      padding-left: 16px;
      padding-right: 16px;
    }
  }
`;
